import { gql } from '@apollo/client';

import { SIP_FRAGMENT } from './investment';

export const GOAL_FRAGMENT = gql`
  ${SIP_FRAGMENT}
  fragment GoalFragment on Goal {
    id
    name
    description
    type
    targetAmountInCents
    currentAmountInCents
    startDate
    endDate
    projectedRateOfReturn
    contributionsAfter18
    status
    shared
    partners {
      id
      firstName
      lastName
    }
    sips {
      ...SipFragment
    }
  }
`;

export const INVITE_FRAGMENT = gql`
  fragment InviteFragment on SentShareGoalInvite {
    id
    goalId
    phoneNumber
    status
    expiry
  }
`;
